import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Card from '../../components/Card'
import OutlineButton from '../../components/OutlineButton'
import Paginate from '../../components/Paginate'
import Paragraph from '../../components/Paragraph'
import Prompts from '../../components/Prompts'
import SectionHeader from '../../components/SectionHeader'
import Slider from '../../components/Slider'
import patient from '../../stores/patient'
import PlanForm from './PlanForm'

const TextArea = styled.textarea`
  background: var(--off-white);
  padding: 0.75rem;
  line-height: 125%;
  overflow-y: auto;
  resize: none;
  height: 15rem;
  width: 100%;
  border: 1px solid transparent;
  display: block;
  &:focus {
    border: 1px solid var(--blue);
  }
`

@observer
export default class PlanSession123 extends Component {
  render() {
    const { session, demo } = this.props
    const firstSession = session === 'first'
    const secondSession = session === 'second'
    const thirdSession = session === 'third'
    const patientID = patient.fields._id
    
    return (
      <Fragment>
        {/* PLAN NOTES */}
        <SectionHeader color="purple" icon="fas fa-edit" str="titles.planNotes" />
        {firstSession &&
          <Prompts>
            {patient.fields.lowVision === "YES"?<Prompts.S str="prose.inTalkingTodayLowVision" />:<Prompts.S str="prose.inTalkingToday" />}
          </Prompts>
        }
        {secondSession &&
          <Prompts>
            <Prompts.P str="prose.thanksForPracticing" />
          </Prompts>
        }
        {thirdSession &&
          <Prompts>
            <Prompts.P><Paragraph str="prose.thirdSessionThanksForPracticing"/></Prompts.P>
          </Prompts>
        }
        <Card>
          <Card.Title str="titles.typePlanNotes" />
          <Card.Pad>
            <TextArea
              name="planNotes"
              value={patient.fields.planNotes}
              onChange={patient.setField}
            />
          </Card.Pad>
        </Card>
        {firstSession &&
          <Prompts>
            <Prompts.Q str="prose.hardToRemember" />
          </Prompts>
        }
        {(secondSession || thirdSession) &&
          <Prompts>
            <Prompts.Q str="prose.whatIfAnyChanges" />
            <Prompts.R str="prose.reflectAndAddToPlan" />
          </Prompts>
        }
        {/* DAILY ROUTINE */}
        <SectionHeader color="purple" icon="fas fa-calendar-check" str="titles.dailyRoutine" />
        {patient.fields.plans.map((_, i) => <PlanForm key={i} index={i} />)}
        <OutlineButton icon="fas fa-calendar-plus" str="titles.addNewPlan" onClick={patient.addPlan} />
        {/* These prompts will change with the slider once that's added. */}
        {firstSession &&
          <Prompts>
            <Prompts.S str="prose.spentTimeTalking" />
            <Prompts.Q str="prose.notTalkedAbout" />
            <Prompts.R str="prose.findItHelpful" />
            <Prompts.Q str="prose.whatSteps" />
            <Prompts.Q str="prose.planIsTo" />
            <Prompts.R str="prose.youAreFeeling" />
            <Prompts.Q str="prose.wroteDownQuestions" />
            {patient.fields.lowVision==="YES"?
              <React.Fragment>
                <Prompts.S str="prose.printYourPlanPageLowVision" />
                <Prompts.S str="prose.thanksForTalkingLowVision" />
              </React.Fragment>
              :<Prompts.S str="prose.printYourPlanPage" />}
          </Prompts>
        }
        {(secondSession || thirdSession) &&
          <Fragment>
            <Prompts>
              <Prompts.S>
                <Card.Header str="titles.chooseASummary" />
                <Paragraph str={secondSession ? "prose.letMeSummarize" : "prose.letMeSummarize2"} />
                <Card.Divider />
                <Paragraph str="prose.canAlsoAskPatient" />
              </Prompts.S>
              <Prompts.R str="prose.itSoundsLike" />
              <Prompts.R str="prose.findItHelpful" />
              <Prompts.Q str="prose.whatSteps" />
              <Prompts.Q str="prose.planIsTo" />
            </Prompts>
            <Card>
              <Card.Title str="prose.howHopeful" />
              <Card.Pad>
                <Slider
                  min={1}
                  max={10}
                  pinColor="purple"
                  value={patient.fields.hopefulness}
                  onChange={patient.setHopefulness}
                />
              </Card.Pad>
            </Card>
            <Prompts>
              {patient.fields.hopefulness >= 7 &&
                <Prompts.R str="prose.soundsLikeFeelingHopeful" />
              }
              {patient.fields.hopefulness < 7 &&
                <Fragment>
                  <Prompts.R str="prose.soundsLikeFeelingNotHopeful" />
                  <Prompts.R str="prose.soundsLikeFurtherDiscuss" />
                  <Prompts.R>
                    <Paragraph str="prose.ifTheySayDontKnow" />
                    <Paragraph str="prose.soundsLikeCouldUse" />
                  </Prompts.R>
                </Fragment>
              }
              {patient.fields.lowVision==="YES"?
                <React.Fragment>
                  <Prompts.S str="prose.printYourPlanPageLowVision" />
                  <Prompts.S str="prose.thanksForTalkingLowVision" />
                </React.Fragment>
                :<Prompts.S str="prose.printYourPlanPage" />
              }
            </Prompts>  
          </Fragment>
        }
        {/* PAGINATE */}
        {!demo &&
          <Paginate>
            <Paginate.Button
              color="gray"
              str="titles.generateLogin"
              icon="fas fa-print"
              onClick={() => window.open(`/print/${patientID}/login`, '_blank')}
            />
            <Paginate.Button
              color="gray"
              str="titles.printPlan"
              icon="fas fa-print"
              onClick={() => window.open(`/print/${patientID}/plan`, '_blank')}
            />
          </Paginate>
        }
        {demo &&
          <Paginate>
            <Paginate.Button prev
              color="red"
              str="titles.goal"
              icon="fas fa-chevron-left"
              to="/demo/goal"
            />
            <Paginate.Button
              color="gray"
              str="titles.printPlan"
              icon="fas fa-print"
              to="/demo/print"
            />
          </Paginate>
        }
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Plan/PlanSession123.js